import React, { useCallback, useEffect, useState } from "react";
import { Box,Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Container } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {  setLocalStorageItem, getLocalStorageItem } from "../../_helpers";
import { surveyActions } from "../../_actions";
import { useHistory } from "react-router-dom";
import DataGridV2 from "../../components/DataGridV2";
import { apps, LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import { INITIAL_ROW_SELECTION_MODEL } from "../../components/DataGridV2/constants";
import { getWbProjectColumns } from "./wbProjectUtils";

export function WbProjects(props) {
  const classes = useStyles();
  const apiRef = useGridApiRef();
  const {
    applicationManagerItems,
    getApplicationLoading,
    confirmProjectLinkLoading,
    projectsForLinking = [],
  } = useSelector((state) => state.surveying);
  const { wbProjectsLinkingInfo = [] } = applicationManagerItems || {};
  const app = useSelector((state) => state.app);
  const { t , i18n } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const keyPrefix = app === apps.settingModule ? "SETTING" : "GENERAL";
  const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
  const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
    LOCAL_STORAGE_GRID_KEYS.WB_PROJECTS_PAGINATION[keyPrefix], undefined
  ))
  const [selectedConfirmProjectId, setSelectedConfirmProjectId] = useState(null);
  const rows = wbProjectsLinkingInfo?.map((row, index) => ({
    id: row.wbProjectId || index,
    ...row,
    stopped : !!row.stopped 
  }));

  useEffect(() => {
    if (!confirmProjectLinkLoading && selectedConfirmProjectId)
      setSelectedConfirmProjectId(null);
  }, [confirmProjectLinkLoading]);

  useEffect(() => {
    dispatch(surveyActions.getApplicationManagerActionItem());
    dispatch(surveyActions.getProjectsForLinkingAction());
  }, [history.location.key]);

 
  

  const handleConfirmLinking = (projectId, wbProjectId) => {
    setSelectedConfirmProjectId(projectId);
    dispatch(surveyActions.confirmProject(projectId, wbProjectId));
  };

  const handleUpdateProject = ({ target: { value } }, wbProjectId) => {
    const selectedProject = projectsForLinking.find(
      (p) => p.projectId === value
    );
    dispatch(surveyActions.updateLinkProject(selectedProject, wbProjectId));
  };

const statusOptions =  [
        ...new Set(
          wbProjectsLinkingInfo.map((item) =>
            item.stopped ? "Stopped" : "Active"
          )
        ),
      ].map((status) => ({ value: status, label: status }))

const columns = getWbProjectColumns({t,keyPrefix,i18n,apiRef, wbProjectsLinkingInfo,projectsForLinking, handleUpdateProject,selectedConfirmProjectId, confirmProjectLinkLoading, handleConfirmLinking,statusOptions})
const onPaginationModelChange = useCallback((newPaginationModel) => {
        setPaginationModel(newPaginationModel)
        setLocalStorageItem(
          LOCAL_STORAGE_GRID_KEYS.WB_PROJECTS_PAGINATION[keyPrefix],
          newPaginationModel
        );
      }, [keyPrefix])

      const getWebProjectsPrintAndDownload = ({ isAllSelected = true, idsToExport = [] }) => {
          const userSelectedRows = isAllSelected ? wbProjectsLinkingInfo : idsToExport.map(id => wbProjectsLinkingInfo?.find(item => item?.wbProjectId === id));
          return userSelectedRows;
        };

  return (
    <Container maxWidth={false} className={classes.mainContainer}>
      <Box display="flex" flexDirection="column" sx={{ height: "100%" }}>
       <Box p={2} >
              <Typography className={classes.headerTitle} variant='h6'>{t("settings.wbProjects.title")}</Typography>
            </Box>
            <Box sx={{flex:1,minHeight:0}}>
      <DataGridV2
        localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.WB_PROJECTS_SEARCH_TEXT[keyPrefix]}
        localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.WB_PROJECTS_COLUMN_FILTER[keyPrefix]}
        localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.WB_PROJECTS_COLUMN_SORT[keyPrefix]}
        localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.WB_PROJECTS_COLUMN_ORDER[keyPrefix]}
        localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.WB_PROJECTS_COLUMN_WIDTH[keyPrefix]}
        localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.WB_PROJECTS_COLUMN_VISIBILITY[keyPrefix]}
        apiRef={apiRef}
        checkboxSelection
        rows={rows}
        loading={getApplicationLoading}
        columns={columns}
        pagination
        filterMode="client"
        {...(!!paginationModel && { paginationModel })}
        onPaginationModelChange={onPaginationModelChange}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
        }}
        toolbarProps={{
          selectedRows: rowSelectionModel,
          getData: getWebProjectsPrintAndDownload
        }}
      />
      </Box>
      </Box>
    </Container>
  );
}

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height:'100%',
    width: "100%",
    overflow: "auto",
    padding: theme.spacing(0),
    background: theme.palette.common.white,
  },
}));
